export const API_URL = 'https://car-manager-server.onrender.com/api';
